import { render, staticRenderFns } from "./BrandableModal.vue?vue&type=template&id=7c166eee&scoped=true&"
import script from "./BrandableModal.vue?vue&type=script&lang=js&"
export * from "./BrandableModal.vue?vue&type=script&lang=js&"
import style0 from "./BrandableModal.vue?vue&type=style&index=0&id=7c166eee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c166eee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Globaltask\\Documents\\Happybox Store\\Happybox Site\\swag\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c166eee')) {
      api.createRecord('7c166eee', component.options)
    } else {
      api.reload('7c166eee', component.options)
    }
    module.hot.accept("./BrandableModal.vue?vue&type=template&id=7c166eee&scoped=true&", function () {
      api.rerender('7c166eee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Swag/components/BrandableModal.vue"
export default component.exports